module.exports = __webpack_public_path__ + "static/img/3.660ab4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/board/components/DownloadData/images/3.png
// module id = w6pW
// module chunks = 1